import React, { useState, useEffect } from 'react';
import * as ReactDOMClient from 'react-dom/client';

import milestoneMap from './EditMilestones/MilestoneMap';
import ImageUpload from './Common/ImageUpload';
import TextArea from './Common/TextArea';

window.milestoneMarkers = [];

const TEXTAREA_CHAR_COUNT = 3000;

const EditMilestones = () => {
	const [milestones, setMilestones] = useState([]);
	const [globalSettings, setGlobalSettings] = useState(window.milestoneGlobalSettings);
	const [saving, setSaving] = useState(false);
	const [loading, setLoading] = useState(true);
	const [reachedMaximum, setReachedMaximum] = useState(false);

	const [validMilestonesError, setValidMilestonesError] = useState(false);

	const missionId = window.missionId;
	const missionDistance = window.missionDistance;
	const distanceUnit = window.distanceUnit;
	const milestoneImageGenURL = '/imagegen/milestones/markers/'+missionId+'/';


	useEffect(() => {
		fetch('/default/ajax?ajax=editmilestones_get_milestones&mission_id='+missionId, {
			method: 'GET',
			headers: {
				Accept: 'application/json'
			}
		})
		.then(res => res.json())
	    .then(
	        async (data) => {
	        	window.addEventListener('loadedMilestones', () => {
	        		setLoading(false);
	        	});	

	        	window.addEventListener('maxMilestones', () => {
	        		setReachedMaximum(true);
	        	});	

	        	await milestoneMap(data.milestones);
	        },
	        // Note: it's important to handle errors here
	        // instead of a catch() block so that we don't swallow
	        // exceptions from actual bugs in components.
	        (error) => {
	        	console.log(error);
	        }
	    )
	}, []);

	useEffect(() => {
		document.querySelector('#edit-milestones-map-canvas-wrapper').style.display = "block";

		const updateMarkers = (e) => {
			const milestoneMarkers = window.milestoneMarkers; // need spread?

			function cmp(a, b) {
				if (a.marker.get('distance') < b.marker.get('distance')) {
					return -1;
				}
				else if (a.marker.get('distance') > b.marker.get('distance')) {
					return 1;
				}

				return 0;
			}
			milestoneMarkers.sort(cmp);

			setMilestones([...milestoneMarkers]); // without the spread parameter, you're giving React the same array it already has so the diff won't change. It may have a new index but React doesn't realise this
		}

		// Listen to milestone marker changes
		window.addEventListener('milestoneMarkersUpdated', updateMarkers);	
		
		return () => {
			window.removeEventListener('milestoneMarkersUpdated', updateMarkers);
		}
	}, []);

	useEffect(() => {
		// only necessary after an e.g. setMilestones() call
		if (!loading && milestones.length > 0) {
			for (var i = milestones.length - 1; i >= 0; i--) {
				let markerIcon = {
					size: new google.maps.Size(44, 160),
				    // The origin for this image is (0, 0).
				    origin: new google.maps.Point(0, 0),
					url: milestoneImageGenURL + (i+1) +'.png',
					anchor: new google.maps.Point(22, 80)
				};

				let existingIcon = milestones[i].marker.getIcon();

				if (typeof existingIcon !== 'undefined' && markerIcon.url !== existingIcon.url) {
					milestones[i].marker.setIcon(markerIcon);
				}
				else if (typeof existingIcon === 'undefined') {
					milestones[i].marker.setIcon(markerIcon);
				}
			}

			window.milestoneMarkers = milestones;	
		}
	}, [milestones, loading]);

	const numberWithCommas = (x) => {
	    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const handleChange = (event, index) => {
    	setValidMilestonesError(false);

		const target = event.target;
	    //const value = target.name === 'isGoing' ? target.checked : target.value;
	    const value = target.value;
	    const name = target.name;

	    const milestoneMarkers = window.milestoneMarkers;

	    milestoneMarkers[index][name] = value;

	    setMilestones([
	    	...milestoneMarkers,
    	]);
	}

	const handleTextareaInit = (event, index) => {
		const milestoneMarkers = window.milestoneMarkers;

		const editor = event.target;
		const wordcount = editor.plugins.wordcount;

		const charcount = wordcount.body.getCharacterCount();

		milestoneMarkers[index]['charcount'] = charcount;

		/* setMilestones([
			...milestoneMarkers,
		]); */
	}

	const handleTextareaChange = (value, editor, index) => {
		setValidMilestonesError(false);

		const milestoneMarkers = window.milestoneMarkers;

		const wordcount = editor.plugins.wordcount;
		const charcount = wordcount.body.getCharacterCount();
		
		milestoneMarkers[index]['description'] = value;
		milestoneMarkers[index]['charcount'] = charcount;	

		setMilestones([
			...milestoneMarkers,
		]);
	}

	const handleGlobalChange = (event) => {
		const target = event.target;
	    const value = target.name === 'showOnMap' ? target.checked : target.value;
	    const name = target.name;

	    setGlobalSettings({ ...globalSettings, [name]: value });
	}

	const updateMilestoneImage = (index, image) => {
		const milestoneMarkers = window.milestoneMarkers;

	    milestoneMarkers[index].image = image;

	    setMilestones([
	    	...milestoneMarkers,
    	]);
	}

	const saveMilestones = () => {
		setSaving(true);
    	setValidMilestonesError(false);

		const formData = new FormData();

		formData.append('show_on_map', globalSettings.showOnMap);
		formData.append('mission_id', missionId);

		let validMilestones = 0;

		for (var i = milestones.length - 1; i >= 0; i--) {
			let milestoneMarker = milestones[i];
			

			// distance > 0 required for now. Issue likely in SnapToRoute where the marker doesn't show on page load.
			if (milestoneMarker.title != '' && milestoneMarker.marker.get('distance') > 0 && (typeof milestoneMarker.charcount === 'undefined' || milestoneMarker.charcount <= TEXTAREA_CHAR_COUNT)) {
				validMilestones++;

				formData.append('milestones['+i+'][distance]', milestoneMarker.marker.get('distance'));
				formData.append('milestones['+i+'][description]', milestoneMarker.description);
				formData.append('milestones['+i+'][title]', milestoneMarker.title);
				formData.append('milestones['+i+'][lat]', milestoneMarker.marker.getPosition().lat());
				formData.append('milestones['+i+'][lng]', milestoneMarker.marker.getPosition().lng());

				if (typeof milestoneMarker.image !== 'undefined') {
					formData.append('milestones['+i+'][image]', milestoneMarker.image.path);
				}

				if (milestoneMarker.dbId !== 'new') {
					formData.append('milestones['+i+'][id]', milestoneMarker.dbId);
				}
				else {
					formData.append('milestones['+i+'][new_id]', milestoneMarker.id);
				}
			}
		}


		if (validMilestones < milestones.length) {
        	setValidMilestonesError('At least one of your milestones does not have a title or its description is too long, please resolve and try again.');

        	setSaving(false);
		}
		else {
			fetch('/default/ajax?ajax=editmilestones_save_milestones', {
				method: 'POST',
				body: formData,
				headers: {
					Accept: 'application/json'
				}
			})
			.then(res => res.json())
		    .then(
		        (data) => {
		        	if (typeof data !== 'undefined' && data.result === 'success') {
						if (data.milestones) {

							for (var i = milestones.length - 1; i >= 0; i--) {
								// Find in the added milestone array
								let loopedMilestone = milestones[i];

								let dbMilestone;

								for (var j = data.milestones.length - 1; j >= 0; j--) {
									if (loopedMilestone.dbId > 0) {
										if (data.milestones[j].id === loopedMilestone.dbId) {
											dbMilestone = data.milestones[j];
											break;
										}
									}
									else if (parseInt(data.milestones[j].new_id) === parseInt(loopedMilestone.id)) {
										dbMilestone = data.milestones[j];
										break;
									}
								}

								if (dbMilestone) {
									if (typeof dbMilestone.image !== 'undefined') {
										loopedMilestone.image = { path: dbMilestone.image };
									}
									loopedMilestone.dbId = dbMilestone.id;
								}
							}
						}
		        	}
		        	else {
		        		if (typeof data !== 'undefined' && data.error.length > 0) {
		        			setValidMilestonesError(data.error);
		        		}
		        		else {
	        				setValidMilestonesError('An unknown error occurred');
		        		}
		        	}

		        	setTimeout(() => {
		        		setSaving(false);
		        	},1000);

		        	//window.location.reload(true); 
		        },
		        // Note: it's important to handle errors here
		        // instead of a catch() block so that we don't swallow
		        // exceptions from actual bugs in components.
		        (error) => {
		        	console.log(error);

		        	setSaving(false);
		        }
		    )
		}		
	}


	/*useEffect(() => {
		if (saving) {
			
		}
	}, [saving]);*/

	function toMiles(km) {
		var tdis = parseFloat(km) * 0.621371;
		return tdis.toFixed(1);
	}

	return (
		<>	

			{reachedMaximum && (
				<div style={{color:'red',textAlign:'center'}}>
					<div className="row">
						<div className="col-md-11 offset-md-1">
						<p>You have reached the maximum number of milestones (150).</p>

						</div>
					</div>
				</div>
			)}
			

			<div id="edit-milestones-descriptions">


				<div className="row">
					<div className="col-md-11 offset-md-1">
						<h4>Milestones</h4>

						{milestones.length > 0 ? (
							<p>You can add another milestone by clicking on the map path at the desired location. Click and drag the marker once it's placed to move it to a new location.</p>
						) : (
							<p>Add your first milestone by clicking on the map path at the desired location. You can click and drag the marker once it's placed to move it to a new location.</p>
						)}
					</div>
				</div>

				<div id="edit-milestones-global">
					<div className="row">
						<div className="col-md-11 offset-md-1">
							<h4>Global settings</h4>
							<label className="checkbox">
								<input type="checkbox" style={{marginTop:3}} name="showOnMap" value="1" checked={globalSettings.showOnMap} onChange={handleGlobalChange} /> Display milestone markers on the map. This means that everyone will be able to see all the milestone locations when viewing the map.
							</label>
						</div>
					</div>
					
				</div>
				<div className="clearfix"></div><br />

				{loading && (
					<div style={{textAlign:'center'}}><br /><br /><i className="icon icon-spinner icon-spin"></i>&nbsp;&nbsp;Loading milestones..<br /><br /></div>
				)}

				{milestones.length > 0 ? (
					<>
						<ul className="milestones-list">
							{milestones.map((data, index) => {

								let background = milestoneImageGenURL + (index+1) + ".png";

								let distance = (data.marker.get('distance')/1000).toFixed(1);
								let percentThrough = ((distance / missionDistance) * 100).toFixed(1);

								if (distanceUnit === 'mi') {
									distance = toMiles(distance);
								}

								return (
									<li key={index}>
										<div className="row">
											<div className="col-md-1">
												<div className="edit-milestone-name" style={{backgroundImage: `url(${background})`}}></div>
											</div>
											<div className="col-md-6">
												<div className="row">
													<div className="col-md-6">
														<p><strong>Distance: <span className="secondary-color">{numberWithCommas(distance) + ' ' + distanceUnit} ({percentThrough+'%'})</span></strong></p>
													</div>
												</div>
												
												<input type="text" name="title" placeholder="Name of Milestone" label="Title" value={data.title} onChange={event => handleChange(event, index)} className="form-control" maxLength="150" /><br />
												
												<TextArea key={index} name="description" init={{placeholder:"Enter the content for the milestone.."}} value={data.description} onChange={(content, editor) => handleTextareaChange(content, editor, index)} onInit={(event) => handleTextareaInit(event, index)} count={data.charcount} limit={TEXTAREA_CHAR_COUNT} />

												<ImageUpload textContent="Upload image" type="new_milestone" uniqueIdentifier={data.id+'_'+index} onFinish={imageData => updateMilestoneImage(index, imageData.image)} image={data.image} />
											</div>
											<div className="col-md-5">
												{data.image && (
													<>
														<p>&nbsp;</p>
														<img src={"/"+data.image.path} alt="Image preview" />
													</>
												)}
											</div>
										</div>
									</li>
								);
							})}
						</ul>

						{validMilestonesError !== false && (
							<div style={{color:'red',textAlign:'center',marginTop:30}}>
								<div className="row">
									<div className="col-md-11 offset-md-1">
										<p>{validMilestonesError}</p>
									</div>
								</div>
							</div>
						)}
						<div style={{width:180,marginTop:50,marginLeft:'auto',marginRight:'auto'}}>
							<button className="btn btn-primary" style={{backgroundColor: (saving ? '#2e97ff' : '#184ABD') }} onClick={saveMilestones} disabled={saving ? true : false}>{saving ? <SavingPleaseWait /> : 'Save changes'}</button>
						</div>
					</>
				) : (
					<div style={{width:180,marginTop:50,marginLeft:'auto',marginRight:'auto'}}>
						<button className="btn btn-primary" style={{backgroundColor: (saving ? '#2e97ff' : '#184ABD') }} onClick={saveMilestones} disabled={saving ? true : false}>{saving ? <SavingPleaseWait /> : 'Save changes'}</button>
					</div>
				)}
				

			</div>
		</>
	)
}

const SavingPleaseWait = () => {
	return (
		<>
			<i className="icon icon-spinner icon-spin"></i>&nbsp;&nbsp;Saving, please wait..
		</>
	);
}

const rctEditMilestones = document.getElementById('rct-editmilestones');

if (rctEditMilestones !== null) {
	ReactDOMClient.createRoot(rctEditMilestones).render(<EditMilestones />);
}